/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { People1PlusIcon16Light } from './People1PlusIcon16Light';
import { People1PlusIcon16Regular } from './People1PlusIcon16Regular';
import { People1PlusIcon16Solid } from './People1PlusIcon16Solid';
import { People1PlusIcon20Light } from './People1PlusIcon20Light';
import { People1PlusIcon20Regular } from './People1PlusIcon20Regular';
import { People1PlusIcon20Solid } from './People1PlusIcon20Solid';
import { People1PlusIcon24Regular } from './People1PlusIcon24Regular';
import { People1PlusIcon24Solid } from './People1PlusIcon24Solid';
import { People1PlusIcon32Regular } from './People1PlusIcon32Regular';
import { People1PlusIcon64Regular } from './People1PlusIcon64Regular';
var sizes = {
    16: {
        light: People1PlusIcon16Light,
        regular: People1PlusIcon16Regular,
        solid: People1PlusIcon16Solid,
    },
    20: {
        light: People1PlusIcon20Light,
        regular: People1PlusIcon20Regular,
        solid: People1PlusIcon20Solid,
    },
    24: {
        regular: People1PlusIcon24Regular,
        solid: People1PlusIcon24Solid,
    },
    32: {
        regular: People1PlusIcon32Regular,
    },
    64: {
        regular: People1PlusIcon64Regular,
    },
};
export var People1PlusIcon = forwardRef('People1PlusIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
